// The member's onboarding row, as one shared query definition.
//
// Settings, Profile, Connectors, the weather rail, the units and distance
// preferences, the preferred first name and the manual log modal all read this
// row. When each reader picked its own freshness window, every mount with a
// shorter window than the last fetch refetched it, and GET /api/onboarding
// became the busiest route in core-api. They must agree on the key, the
// fetcher, and the freshness window.
import { queryOptions } from "@tanstack/react-query";
import { getOnboardingStatus } from "./api.js";
import { queryKeys } from "./query-keys.js";
/*
 * The row only changes when the member saves a preference or finishes the
 * wizard, and every one of those writes goes through applyOnboardingDataPatch
 * or invalidateOnboarding below. Ten minutes is long enough that moving around
 * a session never refetches it, and short enough that a change made on another
 * device shows up without a reload.
 */
export const ONBOARDING_STALE_MS = 10 * 60_000;
export function onboardingQuery(client) {
    return queryOptions({
        queryKey: queryKeys.onboarding,
        queryFn: () => getOnboardingStatus(client),
        staleTime: ONBOARDING_STALE_MS,
        refetchOnWindowFocus: false,
    });
}
/**
 * Merges a saved `data` patch into the cached row so readers repaint at once,
 * then invalidates it so the server's merged copy (which may carry keys the
 * server wrote itself) replaces the optimistic one.
 */
export function applyOnboardingDataPatch(queryClient, patch) {
    queryClient.setQueryData(queryKeys.onboarding, (old) => old?.onboarding
        ? { ...old, onboarding: { ...old.onboarding, data: { ...old.onboarding.data, ...patch } } }
        : old);
    invalidateOnboarding(queryClient);
}
/** For writes outside `data` (dietary labels, waitlist, wizard completion). */
export function invalidateOnboarding(queryClient) {
    void queryClient.invalidateQueries({ queryKey: queryKeys.onboarding });
}
//# sourceMappingURL=onboarding-query.js.map